import { createContext } from 'react';

const FilesManagementContext = createContext();

export default FilesManagementContext;
